module.exports = __webpack_public_path__ + "img/Statement.2ebcc072.svg";